// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lobster&family=Lato&family=Philosopher&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Philosopher', sans-serif;
  color: #333;
  scrollbar-width: thin;
  scrollbar-color: #F97B22 #FFF;
}

body::-webkit-scrollbar {
  width: 12px;
}

body::-webkit-scrollbar-track {
  background: #FFF;
}

body::-webkit-scrollbar-thumb {
  background-color: #F97B22;
  border-radius: 20px;
  border: 3px solid #FFF;
}

.footer-text {
  text-align: center;
  background-color: #F97B22;
  color: #FFF;
  padding: 15px 0;
}

.loading-footer {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}

.loading-gif {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.content-empty {
  height: 70vh;
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.content-empty__gif {
  width: fit-content;
  margin: 0 auto;
}

.content-empty__text {
  margin-top: 12px;
  font-size: 20px;
  font-weight: bold;
}

.text-content {
  line-height: 1.5;
  font-family: 'Lato', sans-serif;
}


/* ========================= Header ========================= */
header {
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  background-color: #FFF;
  border-bottom: 1px solid #DDD;
  position: sticky;
  top: 0;
  z-index: 99;
}

h1 {
  font-family: 'Lobster', cursive;
  font-size: 40px;
  color: #F97B22;
}

#drawer {
  display: flex;
  flex-direction: row;
}

#drawer a {
  text-decoration: none;
  color: #F97B22;
  display: block;
  font-size: 20px;
  padding: 0 25px;
  line-height: 70px;
}

#drawer a:hover,
#drawer a:focus {
  text-decoration: underline;
}

#tab-menu {
  display: none;
}

@media screen and (max-width: 670px) {
  header {
    height: 60px;
    padding: 0 20px;
  }

  h1 {
    font-size: 36px;
  }

  #drawer {
    width: 100%;
    top: 60px;
    left: 0;
    text-align: center;
    position: absolute;
    transform: translate(-100%, 0);
    transition: transform 0.3s ease-in-out;
    background-color: #FFF;
    border-bottom: 1px solid #DDD;
    flex-direction: column;
  }

  #drawer.open {
    transform: translate(0, 0)
  }

  #drawer a {
    font-size: 18px;
    line-height: 52px;
    border-top: 1px solid #DDD;
  }

  button {
    background-color: transparent;
    border: none;
    padding: 10px;
  }

  #tab-menu img {
    width: 30px;
  }

  #tab-menu {
    display: block;
  }
}


/* ========================= Skip Link ========================= */
.skip {
  text-decoration: none;
  color: #000;
  font-size: 24px;
  background-color: #0f0;
  padding: 10px;
  position: absolute;
  top: -50px;
  z-index: 100;
}

.skip:focus {
  top: 100px;
}


/* ========================= Hero ========================= */
.hero {
  position: relative;
}

.hero-img {
  width: 100%;
}

.hero-content {
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  text-align: center;
  color: #FFF;
  font-weight: bold;
  font-size: 40px;
  letter-spacing: 0.6rem;
  text-shadow: #F97B22 0px 14px 28px, #F97B22 0px 10px 10px;
}

@media screen and (min-width: 1200px) {
  .hero-img {
    min-width: 1000px;
    margin: 0 auto;
    display: block;
  }
}

@media screen and (min-width: 670px) {
  .hero-content {
    top: 12%;
    color: #FFF;
    font-size: 68px;
    letter-spacing: 2rem;
  }
}


/* ========================= Catalog List ========================= */
.main-content__title {
  margin: 50px 0 15px;
  font-size: 28px;
  text-align: center;
  text-decoration: underline;
  color: #F97B22;
}

.favorite-title {
  margin: 20px 0 15px !important;
}

.main-content__caption {
  text-align: center;
  font-size: 20px;
  padding: 0 20px;
  margin-bottom: 30px;
}

.container-list-restaurant {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 10px 50px;
}

.restaurant-item {
  width: 300px;
  margin: 15px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 4px;
}

.restaurant-item:hover {
  position: relative;
  bottom: 5px;
  transition-duration: 0.7s;
  box-shadow: rgba(0, 0, 0, 0.24) 0 1px 1px;
}

.restaurant-item__header {
  position: relative;
}

.restaurant-item__header__title {
  position: relative;
  top: 20px;
  z-index: 10;
  padding: 4px 0 4px 12px;
  width: 60%;
  background-color: #F97B22;
  color: #FFF;
}

.restaurant-item__header__image {
  position: absolute;
  top: 0;
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px 4px 0 0;
}

.restaurant-item__body {
  margin-top: 180px;
  padding: 10px 20px 30px;
}

.restaurant-item__body__title {
  color: #F97B22;
  text-decoration: none;
  display: inline-block;
  min-width: 44px;
  min-height: 44px;
}

.restaurant-item__body__subtitle {
  margin-bottom: 10px;
}

@media screen and (min-width: 1200px) {
  .main-content__title {
    margin: 80px 0 20px;
    font-size: 32px;
  }

  .container-list-restaurant {
    padding: 0 10px 80px;
  }

  .restaurant-item {
    width: 350px;
    margin: 20px;
  }
}


/* ========================= Restaurant Detail ========================= */
.restaurant-detail {
  padding: 12px;
}

.restaurant-detail__header {
  margin-bottom: 24px;
  text-align: center;
}

.restaurant-detail__header__image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  margin: 0 auto;
  margin-top: 12px;
  display: block;
}

.restaurant-detail__categori {
  margin-bottom: 12px;
}

.restaurant-detail__categori__content__item {
  display: inline-block;
  border: 1px solid #777;
  border-radius: 16px;
  padding: 4px 16px;
  margin: 12px 4px 12px 0;
}

.restaurant-detail__categori__content__item:hover {
  border: 1px solid #f97c2236;
  background-color: #f97c2236;
}

.restaurant-detail__overview {
  margin-bottom: 24px;
}

.restaurant-detail__overview__content {
  margin-top: 8px;
  text-align: justify;
}

.restaurant-detail__menu {
  margin-bottom: 24px;
}

.restaurant-detail__container-menu {
  margin: 12px 0;
  padding: 12px;
  background-color: #f97c2236;
  border-radius: 8px;
}

.restaurant-detail__menu__food,
.restaurant-detail__menu__drink {
  margin: 8px 0 0 1.5rem;
}

.restaurant-detail__review {
  margin-bottom: 24px;
}

.restaurant-detail__review__content {
  margin: 12px 0;
}

.restaurant-detail__review__item {
  padding: 8px 0;
  border-bottom: 1px solid #CCC;
}

.restaurant-detail__review__item__date {
  font-size: 12px;
  font-weight: bold;
  text-align: end;
  margin-top: 4px;
}

.restaurant-detail__review__form {
  margin: 0 auto;
  margin-top: 24px;
}

.restaurant-detail__review__form__content,
.restaurant-detail__review__form__name {
  width: 100%;
  min-height: 50px;
  margin-bottom: 12px;
  padding: 8px 12px;
  font-size: 16px;
  border: none;
  border-radius: 8px;
  background-color: #f97c2236;
}

.restaurant-detail__review__form__name:focus,
.restaurant-detail__review__form__content:focus,
.restaurant-detail__review__form__name:active,
.restaurant-detail__review__form__content:active {
  border: none;
  outline: 1px solid #F97B22;
}

.restaurant-detail__review__form__button {
  width: 50%;
  min-width: 44px;
  min-height: 44px;
  border: 1px solid #F97B22;
  border-radius: 8px;
  cursor: pointer;
  font-size: 18px;
  background-color: #FFF;
  display: block;
  margin: 0 auto;
  margin-top: 8px;
}

.restaurant-detail__review__form__button:hover {
  background-color: #F97B22;
  color: #FFF;
}

@media screen and (min-width: 670px) {
  .restaurant-detail__header__image {
    max-width: 65%;
    height: auto;
  }
}

@media screen and (min-width: 1200px) {
  .restaurant-detail {
    padding: 24px;
    width: 70%;
    margin: 0 auto;
  }

  .restaurant-detail__container {
    display: flex;
    justify-content: space-between;
  }

  .restaurant-detail__container-menu {
    width: 50%;
    margin: 12px 20px;
  }

  .restaurant-detail__review__form {
    width: 75%;
    display: flex;
    flex-direction: column;
  }
}

.favorite {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F97B22;

  position: fixed;
  bottom: 16px;
  right: 16px;
  border-radius: 50%;
  border: 0;

  font-size: 24px;
  color: #FFF;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;;AAGA,+DAA+D;AAC/D;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;IAC9B,sCAAsC;IACtC,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;EACxB;;EAEA;IACE;EACF;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;;AAGA,kEAAkE;AAClE;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;;AAGA,6DAA6D;AAC7D;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,WAAW;IACX,eAAe;IACf,oBAAoB;EACtB;AACF;;;AAGA,qEAAqE;AACrE;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,UAAU;EACV,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;;AAGA,0EAA0E;AAC1E;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;;;EAIE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE;IACE,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;;EAEzB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;;EAET,eAAe;EACf,WAAW;EACX,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lobster&family=Lato&family=Philosopher&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Philosopher', sans-serif;\n  color: #333;\n  scrollbar-width: thin;\n  scrollbar-color: #F97B22 #FFF;\n}\n\nbody::-webkit-scrollbar {\n  width: 12px;\n}\n\nbody::-webkit-scrollbar-track {\n  background: #FFF;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: #F97B22;\n  border-radius: 20px;\n  border: 3px solid #FFF;\n}\n\n.footer-text {\n  text-align: center;\n  background-color: #F97B22;\n  color: #FFF;\n  padding: 15px 0;\n}\n\n.loading-footer {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n\n.loading-gif {\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.content-empty {\n  height: 70vh;\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n}\n\n.content-empty__gif {\n  width: fit-content;\n  margin: 0 auto;\n}\n\n.content-empty__text {\n  margin-top: 12px;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.text-content {\n  line-height: 1.5;\n  font-family: 'Lato', sans-serif;\n}\n\n\n/* ========================= Header ========================= */\nheader {\n  height: 70px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 40px;\n  background-color: #FFF;\n  border-bottom: 1px solid #DDD;\n  position: sticky;\n  top: 0;\n  z-index: 99;\n}\n\nh1 {\n  font-family: 'Lobster', cursive;\n  font-size: 40px;\n  color: #F97B22;\n}\n\n#drawer {\n  display: flex;\n  flex-direction: row;\n}\n\n#drawer a {\n  text-decoration: none;\n  color: #F97B22;\n  display: block;\n  font-size: 20px;\n  padding: 0 25px;\n  line-height: 70px;\n}\n\n#drawer a:hover,\n#drawer a:focus {\n  text-decoration: underline;\n}\n\n#tab-menu {\n  display: none;\n}\n\n@media screen and (max-width: 670px) {\n  header {\n    height: 60px;\n    padding: 0 20px;\n  }\n\n  h1 {\n    font-size: 36px;\n  }\n\n  #drawer {\n    width: 100%;\n    top: 60px;\n    left: 0;\n    text-align: center;\n    position: absolute;\n    transform: translate(-100%, 0);\n    transition: transform 0.3s ease-in-out;\n    background-color: #FFF;\n    border-bottom: 1px solid #DDD;\n    flex-direction: column;\n  }\n\n  #drawer.open {\n    transform: translate(0, 0)\n  }\n\n  #drawer a {\n    font-size: 18px;\n    line-height: 52px;\n    border-top: 1px solid #DDD;\n  }\n\n  button {\n    background-color: transparent;\n    border: none;\n    padding: 10px;\n  }\n\n  #tab-menu img {\n    width: 30px;\n  }\n\n  #tab-menu {\n    display: block;\n  }\n}\n\n\n/* ========================= Skip Link ========================= */\n.skip {\n  text-decoration: none;\n  color: #000;\n  font-size: 24px;\n  background-color: #0f0;\n  padding: 10px;\n  position: absolute;\n  top: -50px;\n  z-index: 100;\n}\n\n.skip:focus {\n  top: 100px;\n}\n\n\n/* ========================= Hero ========================= */\n.hero {\n  position: relative;\n}\n\n.hero-img {\n  width: 100%;\n}\n\n.hero-content {\n  position: absolute;\n  top: 10%;\n  left: 0;\n  right: 0;\n  text-align: center;\n  color: #FFF;\n  font-weight: bold;\n  font-size: 40px;\n  letter-spacing: 0.6rem;\n  text-shadow: #F97B22 0px 14px 28px, #F97B22 0px 10px 10px;\n}\n\n@media screen and (min-width: 1200px) {\n  .hero-img {\n    min-width: 1000px;\n    margin: 0 auto;\n    display: block;\n  }\n}\n\n@media screen and (min-width: 670px) {\n  .hero-content {\n    top: 12%;\n    color: #FFF;\n    font-size: 68px;\n    letter-spacing: 2rem;\n  }\n}\n\n\n/* ========================= Catalog List ========================= */\n.main-content__title {\n  margin: 50px 0 15px;\n  font-size: 28px;\n  text-align: center;\n  text-decoration: underline;\n  color: #F97B22;\n}\n\n.favorite-title {\n  margin: 20px 0 15px !important;\n}\n\n.main-content__caption {\n  text-align: center;\n  font-size: 20px;\n  padding: 0 20px;\n  margin-bottom: 30px;\n}\n\n.container-list-restaurant {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 0 10px 50px;\n}\n\n.restaurant-item {\n  width: 300px;\n  margin: 15px;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  border-radius: 4px;\n}\n\n.restaurant-item:hover {\n  position: relative;\n  bottom: 5px;\n  transition-duration: 0.7s;\n  box-shadow: rgba(0, 0, 0, 0.24) 0 1px 1px;\n}\n\n.restaurant-item__header {\n  position: relative;\n}\n\n.restaurant-item__header__title {\n  position: relative;\n  top: 20px;\n  z-index: 10;\n  padding: 4px 0 4px 12px;\n  width: 60%;\n  background-color: #F97B22;\n  color: #FFF;\n}\n\n.restaurant-item__header__image {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 4px 4px 0 0;\n}\n\n.restaurant-item__body {\n  margin-top: 180px;\n  padding: 10px 20px 30px;\n}\n\n.restaurant-item__body__title {\n  color: #F97B22;\n  text-decoration: none;\n  display: inline-block;\n  min-width: 44px;\n  min-height: 44px;\n}\n\n.restaurant-item__body__subtitle {\n  margin-bottom: 10px;\n}\n\n@media screen and (min-width: 1200px) {\n  .main-content__title {\n    margin: 80px 0 20px;\n    font-size: 32px;\n  }\n\n  .container-list-restaurant {\n    padding: 0 10px 80px;\n  }\n\n  .restaurant-item {\n    width: 350px;\n    margin: 20px;\n  }\n}\n\n\n/* ========================= Restaurant Detail ========================= */\n.restaurant-detail {\n  padding: 12px;\n}\n\n.restaurant-detail__header {\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.restaurant-detail__header__image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 12px;\n  margin: 0 auto;\n  margin-top: 12px;\n  display: block;\n}\n\n.restaurant-detail__categori {\n  margin-bottom: 12px;\n}\n\n.restaurant-detail__categori__content__item {\n  display: inline-block;\n  border: 1px solid #777;\n  border-radius: 16px;\n  padding: 4px 16px;\n  margin: 12px 4px 12px 0;\n}\n\n.restaurant-detail__categori__content__item:hover {\n  border: 1px solid #f97c2236;\n  background-color: #f97c2236;\n}\n\n.restaurant-detail__overview {\n  margin-bottom: 24px;\n}\n\n.restaurant-detail__overview__content {\n  margin-top: 8px;\n  text-align: justify;\n}\n\n.restaurant-detail__menu {\n  margin-bottom: 24px;\n}\n\n.restaurant-detail__container-menu {\n  margin: 12px 0;\n  padding: 12px;\n  background-color: #f97c2236;\n  border-radius: 8px;\n}\n\n.restaurant-detail__menu__food,\n.restaurant-detail__menu__drink {\n  margin: 8px 0 0 1.5rem;\n}\n\n.restaurant-detail__review {\n  margin-bottom: 24px;\n}\n\n.restaurant-detail__review__content {\n  margin: 12px 0;\n}\n\n.restaurant-detail__review__item {\n  padding: 8px 0;\n  border-bottom: 1px solid #CCC;\n}\n\n.restaurant-detail__review__item__date {\n  font-size: 12px;\n  font-weight: bold;\n  text-align: end;\n  margin-top: 4px;\n}\n\n.restaurant-detail__review__form {\n  margin: 0 auto;\n  margin-top: 24px;\n}\n\n.restaurant-detail__review__form__content,\n.restaurant-detail__review__form__name {\n  width: 100%;\n  min-height: 50px;\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  font-size: 16px;\n  border: none;\n  border-radius: 8px;\n  background-color: #f97c2236;\n}\n\n.restaurant-detail__review__form__name:focus,\n.restaurant-detail__review__form__content:focus,\n.restaurant-detail__review__form__name:active,\n.restaurant-detail__review__form__content:active {\n  border: none;\n  outline: 1px solid #F97B22;\n}\n\n.restaurant-detail__review__form__button {\n  width: 50%;\n  min-width: 44px;\n  min-height: 44px;\n  border: 1px solid #F97B22;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 18px;\n  background-color: #FFF;\n  display: block;\n  margin: 0 auto;\n  margin-top: 8px;\n}\n\n.restaurant-detail__review__form__button:hover {\n  background-color: #F97B22;\n  color: #FFF;\n}\n\n@media screen and (min-width: 670px) {\n  .restaurant-detail__header__image {\n    max-width: 65%;\n    height: auto;\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .restaurant-detail {\n    padding: 24px;\n    width: 70%;\n    margin: 0 auto;\n  }\n\n  .restaurant-detail__container {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .restaurant-detail__container-menu {\n    width: 50%;\n    margin: 12px 20px;\n  }\n\n  .restaurant-detail__review__form {\n    width: 75%;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.favorite {\n  width: 55px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #F97B22;\n\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  border-radius: 50%;\n  border: 0;\n\n  font-size: 24px;\n  color: #FFF;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
